import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators, } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ChangePasswordVerificationDialog } from '../../pages/auth/change-password-verification-dialog/change-password-verification-dialog';
import { SharedService } from '../../services/shared-service/shared.service';

@Component({
  selector: 'app-change-password',
  standalone: false,
  templateUrl: './change-password.html',
  styleUrl: './change-password.scss'
})
export class ChangePassword {
  changePassForm!: FormGroup;
  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  submitted: boolean = false;
  isChangePassFormSubmitted: boolean = false;;
  userId: any = 0;
  decryptUserId: any;

  constructor(
    private readonly dialogRef: MatDialogRef<ChangePassword>,
    private readonly spinner: NgxSpinnerService,
    private readonly toastr: ToastrService,
    private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly fb: FormBuilder,
    private readonly sharedService: SharedService,
    private readonly dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.createChangePasswordForm();
    this.userId = this.sharedService.getValue('userId');
    if (this.userId != null && this.userId != undefined && this.userId != '' && this.userId != 'undefined') {
      this.decryptUserId = this.commonService.Decrypt(this.userId);
      this.userId = this.decryptUserId;
    }
  }

  createChangePasswordForm() {
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%^&*])[A-Za-z\d!@#\$%^&*]{8,}$/;
    this.changePassForm = this.fb.group(
      {
        oldPassword: ['', [Validators.required]],
        newPassword: [
          '',
          [Validators.required, Validators.pattern(passwordPattern)],
        ],
        confirmNewPassword: ['', [Validators.required]],
      },
      {
        validator: this.passwordMatchValidator,
      }
    );
  }

  passwordMatchValidator(formGroup: FormGroup): ValidationErrors | null {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmNewPassword')?.value;
  
    if (!confirmPassword) return null;
  
    return newPassword !== confirmPassword ? { mismatch: true } : null;
  }

  togglePasswordVisibility(fieldName: string) {
    this[fieldName] = !this[fieldName];
  }

  submitChangePassForm() {
    this.isChangePassFormSubmitted = true;
    if (this.changePassForm.valid) {
      this.spinner.show();
      let api = this.api.apiUrl.Account.ChangePassword;
      let obj = {
        OldPassword: this.changePassForm.value.oldPassword.trim(),
        NewPassword: this.changePassForm.value.newPassword.trim(),
        ConfirmPassword: this.changePassForm.value.confirmNewPassword.trim(),
      };
      this.commonService.doPost(api, obj).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            
            const uniqueId = this.commonService.Decrypt(this.sharedService.getValue('uniqueId'));
            const userId = this.commonService.Decrypt(this.sharedService.getValue('userId'));
            const emailId = this.commonService.Decrypt(this.sharedService.getValue('emailId'));
            const oldPassword = this.changePassForm.value.oldPassword;
            const newPassword = this.changePassForm.value.newPassword;
            const confirmNewPassword = this.changePassForm.value.confirmNewPassword

            this.changePassForm.reset();
            this.isChangePassFormSubmitted = false;
            this.toastr.success(response.message);
            this.spinner.hide();

            this.openDialog(uniqueId, emailId, userId, oldPassword, newPassword, confirmNewPassword);
          } else {
            this.toastr.error(response.message);
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.spinner.hide();
          console.error(err);
        }
      });
    }
  }

  get changePasswordFormControls() {
    return this.changePassForm?.controls;
  }

  openDialog(uniqueId: string, emailId: string, userId: any, oldPassword: any, newPassword: any, confirmNewPassword: any) {
    const dialogRef = this.dialog.open(ChangePasswordVerificationDialog, {
      maxWidth: '680px',
      disableClose: true,
      width: '80%',
      data: { uniqueId, emailId, userId, oldPassword, newPassword, confirmNewPassword }
    });

    dialogRef.afterClosed().subscribe();
  }
  close() {
    this.dialogRef.close(false);
  }
}